import type {ChangeExpedientCustomerFormPayload} from "./change-expedient-customer.schema";
import {ChangeExpedientCustomerBody} from "@project/sdk/sales/zod";
import {changeExpedientCustomer} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../expedient-keys";

export function changeExpedientCustomerMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.changeExpedientCustomer,
    mutationFn: (payload: ChangeExpedientCustomerFormPayload) =>
      changeExpedientCustomer(id, ChangeExpedientCustomerBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: expedientKeys.detail(id)}),
        client.invalidateQueries({queryKey: expedientKeys.lists()}),
      ]);
    },
  });
}
